var $newsletterForm = $(".js-newsletter_anmeldung_form");

$(function(){
    isSubmitNewsletter = false;

    if($newsletterForm.find(".js-from_submit").val() == 1){
        $newsletterForm[0].reset();
        formMsgBlockShowHide($newsletterForm.find(".js-form_successblock"), 5000);
    }

    $newsletterForm.find(".js-from_submit").on("click", function(event){
        event.preventDefault();

       if(isSubmitNewsletter && typeof isSubmitNewsletter != "undefined") return false;
        $currentButton = $(this);
        $currentButton.addClass("button_disabled")
        isSubmitNewsletter = true;

        var validSubmit = true;
        var errorCount = 0;

        $.each($newsletterForm.find(".js-form_input"), function(key, value){
            validInput = checkInput($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        $newsletterForm.find(".js-form_checkbox").each(function(){
            validInput = checkCheckbox($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        if(validSubmit){
            showLoader();

            requestData = "";
            if(typeof $newsletterForm[0] != "undefined"){
                $newsletterForm.each(function(index){
                    requestData += "&" + $(this).serialize();
                });
            }

            $.ajax({
                url:$(this).data("ajax"),
                data:requestData,
                type:"POST"
            }).done(function(errors){
                $currentButton.removeClass("button_disabled")
                isSubmitNewsletter = false;

                if(errors == ""){
                    $.ajax({
                        url:$(".js-newsletter_anmeldung_form").attr("action"),
                        data:requestData,
                        type:"POST"
                    }).done(function(response){
                        $newsletterForm[0].reset()
                        formMsgBlockShow($newsletterForm.find(".js-form_successblock"));

                    })
                }else{
                    var errorCount = 0;
                    errors = JSON.parse(errors);

                    $.each(errors, function(key, value){
                        var $field = $("[name=" + value + "]");
                        var $label = $field.siblings(".js-form_label");

                        // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
                        var label_text = $field.attr("label_text");
                        if(typeof label_text == 'undefined' || label_text.length == 0) label_text = $field.attr("placeholder");

                        $label.addClass("form_label_text-error");
                        $label.text(label_text + " - " + $field.attr("title"));
                        errorCount++;
                    });
                    formMsgBlockShow($newsletterForm.find(".js-form_errorblock"));
                }
                hideLoader();
            });
        }else{
            $currentButton.removeClass("button_disabled")
            isSubmitNewsletter = false;
            formMsgBlockShow($newsletterForm.find(".js-form_errorblock"));
            hideLoader();
        }
    });
});


